/* --- inline script 1 --- */

  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  // Force scroll-to-top on every load, unless the URL has an explicit #anchor
  // (in which case the user actively navigated to that section and we honor it).
  if (!window.location.hash) {
    window.addEventListener('beforeunload', function(){ window.scrollTo(0, 0); });
    window.addEventListener('pageshow', function(){ window.scrollTo(0, 0); });
  }


/* --- inline script 2 --- */

// Disable browser scroll-restoration so refresh always lands at the top
if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

// ───────── Hero image-column lock — 3-state machine, jitter-free ─────────
// natural   → image in flow at top of wrapper (initial state)
// locked    → image at position:fixed, bottom: STICKY_BAR_GAP, while scrolling through hero
// exiting   → image at position:absolute, bottom: 0 within wrapper; scrolls naturally with the hero
//             so the column slides cleanly OUT of the hero into the next section instead of disappearing.
// Each transition is ONE DOM write. No per-scroll writes during steady state.
(function setupHeroLock(){
  const BREAKPOINT = 900;
  const STICKY_BAR_GAP = 80;
  const hero  = document.querySelector('section[data-section="hero"]');
  const wrap  = document.querySelector('.hero-images-wrap');
  const imgs  = document.querySelector('.hero-images');
  if (!hero || !wrap || !imgs) return;

  let state = '';

  function setNatural() {
    if (state === 'natural') return;
    imgs.style.position = '';
    imgs.style.bottom   = '';
    imgs.style.top      = '';
    imgs.style.left     = '';
    imgs.style.right    = '';
    imgs.style.width    = '';
    state = 'natural';
  }
  function setLocked() {
    const rect = wrap.getBoundingClientRect();
    if (state === 'locked') {
      // already locked — only update left/width if needed (e.g. after resize)
      imgs.style.left  = rect.left + 'px';
      imgs.style.width = rect.width + 'px';
      return;
    }
    imgs.style.position = 'fixed';
    imgs.style.bottom   = STICKY_BAR_GAP + 'px';
    imgs.style.top      = 'auto';
    imgs.style.left     = rect.left + 'px';
    imgs.style.right    = 'auto';
    imgs.style.width    = rect.width + 'px';
    state = 'locked';
  }
  function setExiting() {
    if (state === 'exiting') return;
    // Position the column anchored to the bottom of its (relatively-positioned) wrapper.
    // As the wrapper scrolls out, the column scrolls out with it — smooth exit, no jump.
    imgs.style.position = 'absolute';
    imgs.style.bottom   = '0';
    imgs.style.top      = 'auto';
    imgs.style.left     = '0';
    imgs.style.right    = '0';
    imgs.style.width    = 'auto';
    state = 'exiting';
  }

  function update() {
    if (window.innerWidth < BREAKPOINT) { setNatural(); return; }

    const wRect = wrap.getBoundingClientRect();
    const vh    = window.innerHeight;
    const ih    = imgs.offsetHeight;
    const effectiveVh   = vh - STICKY_BAR_GAP;
    const naturalBottom = wRect.top + ih;

    if (naturalBottom >= effectiveVh) {
      // Phase 1: still natural-flow — images visible at top of wrapper
      setNatural();
    } else if (wRect.bottom > effectiveVh) {
      // Phase 2: locked above sticky cart bar
      setLocked();
    } else {
      // Phase 3: exiting — image rides the wrapper's bottom edge out of the hero
      setExiting();
    }
  }

  function handleResize() {
    if (state === 'locked') {
      const rect = wrap.getBoundingClientRect();
      imgs.style.left  = rect.left + 'px';
      imgs.style.width = rect.width + 'px';
    }
    update();
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', handleResize);
  requestAnimationFrame(update);
})();

// ───────── Pricing matrix ─────────
const SERIES_PRICES = {
  signature: { twin:99, twinxl:109, full:119, queen:129, calking:139, king:139 },
  premier:   { twin:229, twinxl:239, full:249, queen:259, calking:269, king:279 }
};
const SERIES_MSRP = {
  signature: { twin:199, twinxl:209, full:219, queen:229, calking:239, king:239 },
  premier:   { twin:299, twinxl:319, full:339, queen:359, calking:379, king:399 }
};
const SIZE_LABELS = { twin:'Twin', twinxl:'Twin XL', full:'Full', queen:'Queen', calking:'Cal King', king:'King' };
const FIRMNESS_LABELS = {
  'soft':'Soft / Ultra Plush',
  'medium-soft':'Medium-Soft / Plush',
  'medium':'Medium',
  'medium-firm':'Medium-Firm',
  'firm':'Firm'
};
const FIRMNESS_DESC = {
  'soft': 'Cloud-like sink. For lighter side sleepers (under 140 lbs) on a firm mattress.',
  'medium-soft': "Side-sleeper pressure relief at the hip and shoulder. Doesn't bottom out.",
  'medium': 'Balanced. For combination sleepers or couples splitting firmness preferences.',
  'medium-firm': 'For back sleepers, or side sleepers over 200 lbs who need more support.',
  'firm': 'For stomach sleepers or anyone whose mattress is too soft and sagging.'
};
const SERIES_LABELS = {
  signature: { label: 'Hushfold', sub: 'CoolWeave™ Quilted Fiber, 3"' },
  premier:   { label: 'Premier Series',   sub: 'Cooling Gel Memory Foam, 3"' }
};
const BUNDLE_DISCOUNT = { '1':0, '2':0.10, '3':0.20 };
const UPSELL_PRICES = { pillow: 69, protector: 49, bundle: 99, none: 0 };
const UPSELL_LABELS = { pillow: 'Side-Sleeper Pillow', protector: 'DryFold™ Waterproof Mattress Protector', bundle: 'Sleep Bundle (Pillow + DryFold™ Protector)', none: '' };

// State
// Each topper is independently configured (series, firmness, size).
// state.toppers grows or shrinks based on the selected quantity.
const state = {
  toppers: [
    { series: 'signature', firmness: 'medium-soft', size: 'twin' }
  ],
  upsell: []
};

// ───────── UTM / search-term-driven size pre-selection ─────────
// If the user lands from an ad / SERP with a size in the query string or referrer,
// auto-select that size on Topper 1 AND inject the size into the H1 + sticky bar.
// Common params checked: utm_term, utm_keyword, q, query, keyword, kw, search, term, size
// Sizes detected (longest first to avoid "king" matching "california king"):
//   california king / cal king / calking / cal-king  → calking
//   twin xl / twin-xl / twinxl                       → twinxl
//   king                                             → king
//   queen                                            → queen
//   full / double                                    → full
//   twin                                             → twin
const SIZE_DETECT = [
  { key: 'calking', patterns: ['california king', 'cal king', 'calking', 'cal-king'] },
  { key: 'twinxl',  patterns: ['twin xl', 'twin-xl', 'twinxl', 'twin x-l'] },
  { key: 'king',    patterns: ['king'] },
  { key: 'queen',   patterns: ['queen'] },
  { key: 'full',    patterns: ['full', 'double'] },
  { key: 'twin',    patterns: ['twin'] }
];
function detectSizeFromText(text){
  if (!text) return null;
  const t = (' ' + text.toLowerCase().replace(/\+/g, ' ').replace(/[_\-]+/g, ' ') + ' ');
  for (const { key, patterns } of SIZE_DETECT) {
    for (const p of patterns) {
      if (t.includes(' ' + p + ' ') || t.includes(' ' + p + 's ')) return key;
    }
  }
  return null;
}
function readIncomingSize(){
  try {
    const params = new URLSearchParams(window.location.search);
    const candidates = ['size', 'utm_term', 'utm_keyword', 'q', 'query', 'keyword', 'kw', 'search', 'term'];
    for (const k of candidates) {
      const v = params.get(k);
      const hit = detectSizeFromText(v);
      if (hit) return hit;
    }
    // Hash fallback (#queen, #size=queen)
    if (window.location.hash) {
      const hit = detectSizeFromText(window.location.hash);
      if (hit) return hit;
    }
    // Referrer fallback — Google SERP search query is usually in `q=`
    if (document.referrer) {
      try {
        const ref = new URL(document.referrer);
        const refQ = ref.searchParams.get('q') || ref.searchParams.get('query');
        const hit = detectSizeFromText(refQ);
        if (hit) return hit;
      } catch(_) {}
    }
  } catch(_) {}
  return null;
}
const incomingSize = readIncomingSize();
if (incomingSize && state.toppers[0]) {
  state.toppers[0].size = incomingSize;
}

// Selection handlers — buttons fire click events
document.querySelectorAll('[data-selector]').forEach(btn => {
  if (btn.tagName === 'SELECT') return; // selects use change events (handler below)
  btn.addEventListener('click', e => {
    const selector = btn.getAttribute('data-selector');
    const value = btn.getAttribute('data-value');
    const idxAttr = btn.getAttribute('data-topper-index');
    const idx = idxAttr === null ? null : parseInt(idxAttr, 10);

    if (selector === 'qty') {
      setQty(parseInt(value, 10));
    } else if (selector === 'upsell') {
      const _i = state.upsell.indexOf(value);
      if (_i >= 0) state.upsell.splice(_i, 1);
      else state.upsell.push(value);
    } else if (idx !== null && state.toppers[idx]) {
      state.toppers[idx][selector] = value;
    }

    syncSelections();
    updateSummary();
  });
});

// Firmness dropdown — selects fire change events
document.querySelectorAll('select[data-selector]').forEach(select => {
  select.addEventListener('change', e => {
    const sel = select.getAttribute('data-selector');
    const idx = parseInt(select.getAttribute('data-topper-index'), 10);
    if (state.toppers[idx]) {
      state.toppers[idx][sel] = select.value;
      syncSelections();
      updateSummary();
    }
  });
});

// "Customize this topper" — expand a collapsed topper panel
document.querySelectorAll('[data-topper-expand]').forEach(btn => {
  btn.addEventListener('click', e => {
    e.stopPropagation();
    const panel = btn.closest('.topper-extra');
    if (panel) panel.setAttribute('data-collapsed', 'false');
  });
});

// "Reset to match Topper 1" — copy Topper 1's config AND collapse the panel back
document.querySelectorAll('.copy-from-1').forEach(btn => {
  btn.addEventListener('click', e => {
    e.stopPropagation();
    const targetIdx = parseInt(btn.getAttribute('data-copy-to'), 10);
    if (!state.toppers[targetIdx]) return;
    state.toppers[targetIdx] = { ...state.toppers[0] };
    syncSelections();
    updateSummary();
    // Collapse the panel back to the "Same as Topper 1" summary state
    const panel = btn.closest('.topper-extra');
    if (panel) panel.setAttribute('data-collapsed', 'true');
    btn.classList.add('flashed');
    const original = btn.textContent;
    btn.textContent = 'Reset ✓';
    setTimeout(() => { btn.classList.remove('flashed'); btn.textContent = original; }, 1200);
  });
});

function setQty(newQty){
  if (![1, 2, 3].includes(newQty)) return;
  const current = state.toppers.length;
  if (newQty > current) {
    // Add new toppers initialized as a copy of Topper 1
    const defaults = { ...state.toppers[0] };
    for (let i = current; i < newQty; i++) state.toppers.push({ ...defaults });
  } else if (newQty < current) {
    state.toppers.length = newQty;
  }
  // Show/hide topper-extra panels and reset collapsed state for newly visible ones
  document.querySelectorAll('.topper-extra').forEach(panel => {
    const idx = parseInt(panel.getAttribute('data-topper-index'), 10);
    const wasActive = panel.getAttribute('data-active') === 'true';
    const isActive = idx < newQty;
    panel.setAttribute('data-active', isActive ? 'true' : 'false');
    if (isActive && !wasActive) {
      // Newly visible: start in the collapsed "Same as Topper 1" state
      panel.setAttribute('data-collapsed', 'true');
    }
  });
}

function syncSelections(){
  document.querySelectorAll('[data-selector]').forEach(el => {
    const sel = el.getAttribute('data-selector');
    const val = el.getAttribute('data-value');
    const idxAttr = el.getAttribute('data-topper-index');
    const idx = idxAttr === null ? null : parseInt(idxAttr, 10);

    if (el.tagName === 'SELECT') {
      // Sync select value directly
      if (idx !== null && state.toppers[idx]) {
        el.value = state.toppers[idx][sel];
      }
      return;
    }

    if (sel === 'qty') {
      el.setAttribute('data-selected', state.toppers.length === parseInt(val, 10) ? 'true' : 'false');
    } else if (sel === 'upsell') {
      el.setAttribute('data-selected', state.upsell.includes(val) ? 'true' : 'false');
    } else if (idx !== null) {
      const topper = state.toppers[idx];
      el.setAttribute('data-selected', (topper && topper[sel] === val) ? 'true' : 'false');
    }
  });
  // Firmness descriptions (one per topper)
  document.querySelectorAll('[data-firmness-desc]').forEach(el => {
    const idx = parseInt(el.getAttribute('data-firmness-desc'), 10);
    if (state.toppers[idx]) {
      el.textContent = FIRMNESS_DESC[state.toppers[idx].firmness] || '';
    }
  });
  // Topper 2/3 collapsed summary lines
  document.querySelectorAll('[data-topper-summary]').forEach(el => {
    const idx = parseInt(el.getAttribute('data-topper-summary'), 10);
    const t = state.toppers[idx];
    if (t) {
      el.textContent = SERIES_LABELS[t.series].label.replace(' Series', '') + ' · ' + FIRMNESS_LABELS[t.firmness] + ' · ' + SIZE_LABELS[t.size];
    }
  });
  // Hero image swaps based on Topper 1's series (it's the primary)
  document.querySelectorAll('[data-series-image]').forEach(art => {
    art.setAttribute('data-active', art.getAttribute('data-series-image') === state.toppers[0].series ? 'true' : 'false');
  });
}

function fmt(n){ return '$' + Math.round(n).toLocaleString(); }

function updateSummary(){
  const qty = state.toppers.length;

  // Per-topper subtotals
  let baseSubtotal = 0;
  let baseMsrp = 0;
  const topperRows = state.toppers.map((t, i) => {
    const unit = SERIES_PRICES[t.series][t.size];
    const unitMsrp = SERIES_MSRP[t.series][t.size];
    baseSubtotal += unit;
    baseMsrp += unitMsrp;
    const label = qty === 1 ? 'Your topper' : 'Topper ' + (i + 1);
    const seriesName = SERIES_LABELS[t.series].label.replace(' Series', '');
    return '<div class="summary-topper-row">' +
      '<div>' +
        '<span class="summary-topper-label">' + label + '</span>' +
        '<span class="summary-topper-detail">' + seriesName + ' · ' + FIRMNESS_LABELS[t.firmness] + ' · ' + SIZE_LABELS[t.size] + '</span>' +
      '</div>' +
      '<span class="summary-topper-price">' + fmt(unit) + '</span>' +
    '</div>';
  }).join('');

  // Bundle discount applied to topper subtotal only (not upsells)
  const bundleDiscount = BUNDLE_DISCOUNT[String(qty)] || 0;
  const bundleDiscountAmt = baseSubtotal * bundleDiscount;
  const baseAfterDiscount = baseSubtotal - bundleDiscountAmt;
  const upsellPrice = state.upsell.reduce(function(s, k){ return s + (UPSELL_PRICES[k] || 0); }, 0);
  const total = baseAfterDiscount + upsellPrice;

  // MSRP comparison includes upsell strikethrough delta
  const _UPSELL_MSRP = { pillow: 99, protector: 79, bundle: 178 };
  const upsellMsrp = state.upsell.reduce(function(s, k){ return s + (_UPSELL_MSRP[k] || 0); }, 0);
  const msrpTotal = baseMsrp + upsellMsrp;
  const savings = msrpTotal - total;
  const multi = qty > 1;
  const perTopper = baseAfterDiscount / qty;
  const perTopperMsrp = baseMsrp / qty;

  const set = (key, value) => {
    document.querySelectorAll('[data-summary-key="' + key + '"]').forEach(el => el.innerHTML = value);
  };

  set('toppers-list', topperRows);
  set('msrp', '<s>' + fmt(multi ? perTopperMsrp : msrpTotal) + '</s>');
  set('total', multi ? (fmt(perTopper) + ' <span class="per-topper-unit">/ topper</span>') : fmt(total));
  set('savings', 'You save ' + fmt(savings) + ' vs. retail · plus a free 4-year warranty upgrade');
  // set('cart-count', qty); // disabled — badge now reflects real Shopify cart (see bootstrap)

  // ───────── H1 + sticky bar mirror live config ─────────
  // H1 inserts the primary topper's size word ("Queen ", "Cal King ", "") between 3" and "Mattress Topper"
  // ONLY if the user originally landed with a size in the URL (incomingSize is set).
  // If they came generic, keep the generic H1 even after they pick a size.
  const primarySize = state.toppers[0] ? state.toppers[0].size : 'twin';
  const sizeWord = SIZE_LABELS[primarySize] || '';
  const h1SizeEl = document.querySelector('[data-h1-size]');
  if (h1SizeEl) {
    h1SizeEl.textContent = incomingSize ? (sizeWord + ' ') : '';
  }
  // Sticky bar — mirrors live total, MSRP, and the configured size word
  const stickyNameSize = document.querySelector('[data-sticky-name-size]');
  const stickyLabel = document.querySelector('[data-sticky-label]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const stickyMsrp = document.querySelector('[data-sticky-msrp]');
  const stickyPitch = document.querySelector('[data-sticky-pitch]');
  if (stickyNameSize) {
    stickyNameSize.textContent = (qty === 1) ? (sizeWord + ' ') : '';
  }
  if (stickyLabel) {
    stickyLabel.textContent = (qty === 1) ? 'Your topper' : (qty + ' toppers');
  }
  if (stickyPrice) stickyPrice.innerHTML = multi ? (fmt(perTopper) + '<span class="sp-ea">/ea</span>') : fmt(total);
  if (stickyMsrp) stickyMsrp.textContent = fmt(multi ? perTopperMsrp : msrpTotal);
  if (stickyPitch) {
    const firmnessLabel = FIRMNESS_LABELS[state.toppers[0].firmness] || '';
    const firmShort = firmnessLabel.split(' / ')[0]; // e.g. "Medium-Soft"
    if (qty === 1) {
      stickyPitch.textContent = firmShort + ' · 180-night trial · Free shipping';
    } else {
      stickyPitch.textContent = qty + '-topper bundle · 180-night trial · Free shipping';
    }
  }

  // Bundle discount line
  const bundleLine = document.querySelector('[data-summary-key="bundle-line"]');
  if (bundleLine) {
    if (qty > 1) {
      bundleLine.style.display = '';
      set('bundle-label', 'Bundle discount (' + qty + ' toppers, ' + Math.round(bundleDiscount * 100) + '% off)');
      set('bundle-val', '−' + fmt(bundleDiscountAmt));
    } else {
      bundleLine.style.display = 'none';
    }
  }

  // Upsell breakout line — shows up when pillow or protector is selected
  const upsellLine = document.querySelector('[data-summary-key="upsell-line"]');
  if (upsellLine) {
    if (state.upsell.length > 0) {
      upsellLine.style.display = '';
      const _labels = state.upsell.map(function(k){ return UPSELL_LABELS[k] || 'Add-on'; }).join(' + ');
      set('upsell-label', _labels);
      const _total = state.upsell.reduce(function(s, k){ return s + (UPSELL_PRICES[k] || 0); }, 0);
      set('upsell-val', '+' + fmt(_total));
    } else {
      upsellLine.style.display = 'none';
    }
  }
}

// FAQ accordion
document.querySelectorAll('.faq-q').forEach(q => {
  q.addEventListener('click', () => {
    const item = q.closest('.faq-item');
    const isOpen = item.getAttribute('data-open') === 'true';
    item.setAttribute('data-open', isOpen ? 'false' : 'true');
  });
});

// ───────── Image generation prompts ─────────
// Use any image generator (nano-banana / Gemini / Midjourney). Style preamble for all:
// "Documentary photography, slightly warm color grade, natural morning light (3500K),
//  lived-in American bedroom, slightly desaturated cream-leaning highlights, no pure white,
//  no stock-photo aesthetic, no sterile commercial styling."
const IMAGE_PROMPTS = {
  'hero-signature': `Photograph of a 3-inch quilted cooling-fiber mattress topper on a queen-sized bed in a lived-in American bedroom. The topper is the hero of the frame: standard diamond quilted pattern visible across the surface, soft warm-white 300-thread-count microfiber/cotton cover, simple piped edge binding visible along the side, 3-inch loft. The bed is half-made — a soft folded throw blanket at the foot, plain pillows at the head. A modest wooden nightstand to the right of frame with a paperback book and reading glasses. Sheer linen curtains diffusing soft directional natural morning light from the left (3500K). Color grade: warm-shifted, slightly desaturated, cream-leaning highlights, no pure white. Documentary product photography style — feels real and inhabitable, not styled like a hotel ad or wellness brand. No people in frame. Composition: low oblique angle from the foot-corner of the bed, the topper fills about 60% of the frame. Shot on 50mm prime, f/4, soft depth of field. 1:1 square aspect ratio.`,

  'hero-premier': `Photograph of a premium cooling-gel-infused memory foam mattress topper on a queen-sized bed in a lived-in American bedroom. This is a different product from the Signature (which is quilted fiber) — the Premier is solid CertiPUR-US memory foam with a knit 600-thread-count bamboo cover. The topper has a smooth, dense, foam-block silhouette (not quilted), 3-inch profile clearly visible from the side (noticeably thicker than the 2-inch Signature for direct comparison), with a softly textured bamboo-blend cover in natural ivory. The cover has a fine waffle-knit or honeycomb knit texture that suggests breathability. A cooling gel layer is subtly visible in the side cross-section (a slightly different tone of foam, blue-gray-tinted, near the surface). Show a human hand pressing gently into the surface to demonstrate the memory-foam contour — the foam visibly conforms and holds the impression. The bed is half-made — same composition as Signature shot (matched for direct comparison): low oblique angle from foot-corner, bed fills 60% of frame, modest wooden nightstand on right with paperback book and reading glasses, plus a small ceramic vase with a single stem of dried wheat (premium detail). Sheer linen curtains diffusing soft directional natural morning light from the left (3500K). Color grade: warm-shifted, slightly desaturated, cream-leaning highlights, no pure white. Documentary product photography style — feels real, not stylized commercial stock. Shot on 50mm prime, f/4, soft depth of field. 1:1 square aspect ratio.`,

  'construction-detail': `Macro close-up photograph showing the corner construction of a quilted cooling-fiber mattress topper. Frame shows about 10 inches of the topper surface from a low oblique angle: visible diamond quilted pattern with each stitch and tufting pinch sharp and defined, soft ivory cover fabric texture clear and tactile, the 3-inch loft profile cleanly visible from the side, fine cotton binding running along the edge. Soft natural morning light from the side reveals the dimensional 3D structure of the quilting and the airiness of the fill. No people or full bed visible — just the product detail. Color grade: warm cream highlights, slightly desaturated. Documentary product photography style, not stylized commercial stock. Shot on 90mm macro lens, f/5.6. 1:1 square aspect ratio.`,

  // ───── Signature Series gallery (5 images total — main hero above + 4 here) ─────
  'signature-quilt': `Macro photograph of the top surface of the Signature mattress topper, focused on the diamond quilted texture. Soft warm-white 300TC microfiber/cotton cover with each diamond stitch and tufting pinch sharp and tactile, slight fabric pucker between stitches where the cooling-fiber fill lofts up. Soft directional morning light from upper-left reveals the dimensional 3D structure of the quilting. Filling fibers subtly visible through the weave. No people, no bed context — just the topper surface filling the frame. Warm cream highlights, slightly desaturated. Documentary product photography, not stock. Shot on 90mm macro, f/5.6. 1:1 square aspect ratio.`,

  'signature-side': `Side-profile photograph of the Signature cooling-fiber mattress topper laid on a queen bed. Camera at bed level showing the 3-inch loft profile clearly — the topper sits on the existing mattress underneath with a clean horizontal line where they meet. The topper's top surface shows the gentle quilted texture; the cover binding (simple piped edge) runs along the visible side. Soft natural morning light from the right, slightly warm. The mattress below is in a neutral ivory tone. No people. Documentary product photography style. Shot on 50mm prime, f/5.6. 1:1 square aspect ratio.`,

  'signature-onbed': `Photograph of the Signature cooling-fiber mattress topper sitting on top of a queen mattress in a lived-in American bedroom, viewed from above-side at a 45° angle. The topper covers the mattress fully with its diamond-quilted surface visible across the full bed. Fitted sheet, pillows, and folded throw blanket all neutral cream tones. Soft sheer curtains, modest wooden nightstand visible at the edge of frame. Soft natural morning light at 3500K. Cream-leaning highlights, slightly desaturated, no pure white. Documentary not aspirational. No people in frame. Shot on 35mm prime, f/4. 1:1 square aspect ratio.`,

  'signature-cover': `Extreme macro photograph of the 300TC microfiber/cotton fabric cover of the Signature mattress topper, filling the entire frame. The weave structure is visible — fine thread interlacing, slight texture, soft warm-white tone. A few subtle highlights where the light catches individual threads. Color grade: warm cream, slightly desaturated. No quilting stitches visible — pure fabric texture. Documentary product photography, not stylized. Shot on 100mm macro, f/8. 1:1 square aspect ratio.`,

  // ───── Premier Series gallery (5 images total — main hero above + 4 here) ─────
  'premier-foam': `Macro photograph of a human hand pressing gently into the surface of the Premier cooling-gel-infused memory foam mattress topper. The foam visibly conforms to the hand's pressure — fingers and palm impressions are clear in the foam surface. The 600TC bamboo cover stretches softly over the foam, fine waffle-knit texture visible. As the hand begins to lift, the foam holds the impression briefly before slow recovery. Soft natural morning light from upper-left. Color grade: warm-shifted, slightly desaturated, cream-leaning highlights. Documentary product photography, not stylized. Shot on 50mm, f/5.6. 1:1 square aspect ratio.`,

  'premier-side': `Side-profile photograph of the Premier cooling-gel memory foam mattress topper laid on a queen bed. Camera at bed level showing the 3-inch foam profile clearly (noticeably thicker than a standard 2-inch topper — this is the premium thickness). The cross-section reveals a subtle two-layer construction: the lower portion is the standard memory foam (warm ivory), and the upper portion shows a slightly different tone — a thin cooling-gel infusion layer (very faint blue-gray tint, almost imperceptible). The 600TC bamboo cover wraps the top and sides smoothly, with double-stitched binding visible along the edge. The mattress underneath is neutral ivory. Soft natural morning light from the right. No people. Documentary product photography. Shot on 50mm, f/5.6. 1:1 square aspect ratio.`,

  'premier-onbed': `Photograph of the Premier memory foam mattress topper sitting on top of a queen mattress in a lived-in American bedroom, viewed from above-side at a 45° angle. The topper covers the mattress fully — smooth, dense foam surface visible (not quilted like Signature), 600TC bamboo cover stretched cleanly across the top. Slightly more refined bedroom styling than the Signature shot — pillows neatly arranged, a single small ceramic vase with dried wheat on the modest nightstand. Soft natural morning light at 3500K. Cream-leaning highlights, slightly desaturated. Documentary, not aspirational. No people in frame. Shot on 35mm, f/4. 1:1 square aspect ratio.`,

  'premier-cover': `Extreme macro photograph of the 600TC bamboo-blend fabric cover of the Premier mattress topper, filling the entire frame. Fine waffle-knit or honeycomb knit weave structure visible — subtle bamboo-fiber sheen, slightly cooler-toned ivory than the Signature cover. Soft directional light reveals the dimensional weave pattern. Color grade: warm cream highlights with subtle cool undertones, slightly desaturated. No stitching visible — pure premium fabric texture. Documentary product photography, not stylized. Shot on 100mm macro, f/8. 1:1 square aspect ratio.`,

  'avatar-margaret': `Documentary-style head-and-shoulders portrait of Margaret, a woman in her early 70s. Shoulder-length silver-gray hair, warm undertones, kind eyes, soft visible skin texture and age lines. She's sitting on the edge of her own queen bed in a modest Ohio bedroom in soft morning light, wearing a simple cotton nightgown or worn-in cardigan. Expression calm and quietly content — not triumphant, not performative. Real unstaged composition: no or minimal makeup, no studio backdrop, no posed smile. Lived-in surroundings visible in the soft background — a paperback on the nightstand, a framed family photo, simple curtains. Warm color grade, slightly desaturated, cream-leaning highlights. Square 1:1 aspect ratio.`,

  'avatar-judith': `Documentary-style head-and-shoulders portrait of Judith, a woman in her late 60s. Chin-length salt-and-pepper hair, soft Southern features, warm friendly eyes, visible skin texture and age lines. In her own North Carolina bedroom in soft morning light, wearing a simple cotton blouse or cardigan. Expression calm and quietly satisfied — content but not posed. Real unstaged composition: minimal makeup, no studio backdrop. Lived-in surroundings: a quilt on the bed behind her, simple wood furniture, modest curtains. Warm color grade, slightly desaturated. Square 1:1 aspect ratio.`,

  'avatar-tom': `Documentary-style head-and-shoulders portrait of Tom, a man in his late 50s. Short gray-flecked hair, wire-frame glasses, mountain-state casual look. In his own Colorado bedroom in soft morning light, wearing a simple flannel shirt or cotton t-shirt. Expression calm and quietly content — a guy who's slept well, not performing for the camera. Real unstaged composition: no studio, no posed smile. Lived-in surroundings: simple wood furniture, a book on the nightstand. Warm color grade, slightly desaturated. Square 1:1 aspect ratio.`,

  'avatar-susan': `Documentary-style head-and-shoulders portrait of Susan, a woman in her early 50s. Chestnut shoulder-length hair, warm Southern features, slight crow's feet, kind eyes. In her own Texas bedroom in soft morning light, wearing a simple cotton sleep shirt or loose cardigan. Expression calm and quietly satisfied. Real unstaged composition: minimal makeup, no studio. Lived-in surroundings: simple bedroom furniture, family photo in the background. Warm color grade, slightly desaturated. Square 1:1 aspect ratio.`,

  'avatar-glenda': `Documentary-style head-and-shoulders portrait of Glenda, a woman in her late 60s. Curly gray hair, kind smile, Southern features, visible skin texture and age lines. In her own Tennessee bedroom in soft morning light, wearing a simple cotton nightgown or cardigan. Expression warm and quietly content. Real unstaged composition: minimal or no makeup, no studio backdrop. Lived-in surroundings: family photos on the wall, simple wood furniture. Warm color grade, slightly desaturated. Square 1:1 aspect ratio.`,

  'avatar-eleanor': `Documentary-style head-and-shoulders portrait of Eleanor, a woman in her mid-70s. White wavy hair, wire-frame glasses, Midwest practical look, visible skin texture and age lines. In her own Michigan bedroom in soft morning light, wearing a simple house dress or cardigan. Expression calm and matter-of-fact — practical, not performative. Real unstaged composition: no makeup, no studio. Lived-in surroundings: a paperback novel on the nightstand, simple curtains. Warm color grade, slightly desaturated. Square 1:1 aspect ratio.`
};

// Populate every prompt body from the IMAGE_PROMPTS object
document.querySelectorAll('.img-slot-prompt-body[data-prompt-id]').forEach(el => {
  const id = el.getAttribute('data-prompt-id');
  el.textContent = IMAGE_PROMPTS[id] || '(prompt not defined)';
});

// Copy-to-clipboard for all .img-slot-copy and .avatar-prompt-copy buttons
document.addEventListener('click', e => {
  const btn = e.target.closest('.img-slot-copy, .avatar-prompt-copy');
  if (!btn) return;
  const id = btn.getAttribute('data-prompt-id');
  const text = IMAGE_PROMPTS[id];
  if (!text) return;
  navigator.clipboard.writeText(text).then(() => {
    const original = btn.textContent;
    btn.classList.add('copied');
    btn.textContent = 'Copied to clipboard';
    setTimeout(() => {
      btn.classList.remove('copied');
      btn.textContent = original;
    }, 1800);
  });
});

// ───────── Gallery thumbnail navigation ─────────
// (Removed — Boll & Branch-style hero shows all 6 images in a grid simultaneously)

// (Hero image-column lock removed — images scroll naturally with the page.)

// ───────── Firmness info icon: prevent click from selecting the card ─────────
document.addEventListener('click', e => {
  const info = e.target.closest('.firmness-info');
  if (!info) return;
  e.preventDefault();
  e.stopPropagation();
}, true);

// ───────── Firmness quiz ─────────
// 2-question quiz (sleep position × body weight) that maps to one of the 5
// firmness levels. The "Use this firmness" button programmatically selects
// the matching card on Topper 1.
(function setupFirmnessQuiz(){
  const quiz = document.querySelector('.firmness-quiz');
  if (!quiz) return;

  const state = { position: 'side', weight: 'medium' };

  const REC = {
    'side-light':     { key: 'soft',         name: 'Soft / Ultra Plush',  desc: 'Cloud-like sink. For lighter side sleepers on a firm mattress.' },
    'side-medium':    { key: 'medium-soft',  name: 'Medium-Soft / Plush', desc: "Side-sleeper pressure relief at the hip and shoulder. Doesn't bottom out." },
    'side-heavy':     { key: 'medium',       name: 'Medium',              desc: 'Side-sleeper support with more body for heavier sleepers.' },
    'back-light':     { key: 'medium-soft',  name: 'Medium-Soft / Plush', desc: 'Light back support with a soft top layer.' },
    'back-medium':    { key: 'medium-firm',  name: 'Medium-Firm',         desc: 'Back-sleeper lumbar support without going stiff.' },
    'back-heavy':     { key: 'medium-firm',  name: 'Medium-Firm',         desc: 'Back support that holds up under more body weight.' },
    'stomach-light':  { key: 'firm',         name: 'Firm',                desc: 'For stomach sleepers — keeps the hips from sinking.' },
    'stomach-medium': { key: 'firm',         name: 'Firm',                desc: 'For stomach sleepers — keeps the hips from sinking.' },
    'stomach-heavy':  { key: 'firm',         name: 'Firm',                desc: 'For stomach sleepers — keeps the hips from sinking.' },
    'combo-light':    { key: 'medium-soft',  name: 'Medium-Soft / Plush', desc: 'Balanced for lighter combination sleepers.' },
    'combo-medium':   { key: 'medium',       name: 'Medium',              desc: 'Balanced. For combination sleepers splitting positions.' },
    'combo-heavy':    { key: 'medium',       name: 'Medium',              desc: 'Balanced support for combination sleepers with more body.' }
  };

  const nameEl  = quiz.querySelector('.fq-result-name');
  const descEl  = quiz.querySelector('.fq-result-desc');
  const applyEl = quiz.querySelector('.fq-apply');

  function render() {
    const r = REC[state.position + '-' + state.weight];
    if (!r) return;
    if (nameEl)  nameEl.textContent  = r.name;
    if (descEl)  descEl.textContent  = r.desc;
    if (applyEl) applyEl.setAttribute('data-firmness', r.key);
    if (applyEl && applyEl.classList.contains('applied')) {
      applyEl.classList.remove('applied');
      applyEl.textContent = 'Use this firmness →';
    }
  }

  quiz.querySelectorAll('.fq-options').forEach(group => {
    const q = group.getAttribute('data-q');
    group.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        group.querySelectorAll('button').forEach(b => b.removeAttribute('data-selected'));
        btn.setAttribute('data-selected', 'true');
        state[q] = btn.getAttribute('data-v');
        render();
      });
    });
  });

  if (applyEl) {
    applyEl.addEventListener('click', e => {
      e.preventDefault();
      const firmness = applyEl.getAttribute('data-firmness');
      const card = document.querySelector(
        '.firmness-card[data-topper-index="0"][data-selector="firmness"][data-value="' + firmness + '"]'
      );
      if (card) {
        card.click();
        applyEl.classList.add('applied');
        applyEl.textContent = 'Selected ✓';
        setTimeout(() => {
          // Auto-close the popover
          const details = applyEl.closest('details');
          if (details) details.removeAttribute('open');
        }, 700);
      }
    });
  }

  render();
})();

// ───────── Proof stats: counter animation on scroll into view ─────────
(function setupProofStats(){
  const stats = document.querySelectorAll('.proof-stat');
  if (!stats.length || !('IntersectionObserver' in window)) return;

  const animate = (el) => {
    const target = parseFloat(el.getAttribute('data-count-to'));
    if (isNaN(target)) return;
    const isDecimal = target % 1 !== 0;
    const duration = 900;
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);  // easeOutCubic
      const v = target * eased;
      el.textContent = isDecimal ? v.toFixed(1) : Math.floor(v);
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = isDecimal ? target.toFixed(1) : target;
    };
    requestAnimationFrame(tick);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const card = entry.target;
      if (card.classList.contains('is-revealed')) return;
      card.classList.add('is-revealed');
      card.querySelectorAll('[data-count-to]').forEach(animate);
      observer.unobserve(card);
    });
  }, { threshold: 0.4 });

  stats.forEach((s) => observer.observe(s));
})();

// ───────── Sticky cart bar visibility ─────────
// Show the bottom sticky bar AFTER the user scrolls past the in-page order summary CTA.
// On mobile the bar is always visible (CSS).
// On mobile, hide the bar while the user is over the configurator (between
// the "Build it the way you sleep" heading and the in-page Add to Cart button).
(function setupStickyBar(){
  const bar = document.querySelector('.sticky-cta');
  const summaryCta = document.querySelector('.summary-cta');
  if (!bar) return;

  const isDesktop = () => window.matchMedia('(min-width: 1000px)').matches;

  // Desktop: slide bar up only after user has scrolled past the in-summary CTA.
  if (summaryCta) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!isDesktop()) return; // mobile handled below
        const shouldShow = !entry.isIntersecting;
        bar.classList.toggle('visible', shouldShow);
        document.body.classList.toggle('has-sticky-cta', shouldShow);
      });
    }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
    observer.observe(summaryCta);
  }

  // Mobile: hide the sticky bar while the user is in the configurator zone —
  // i.e. between the "Build it the way you sleep" heading and the in-page
  // Add-to-Cart button. The in-page CTA is the relevant action in that range,
  // so the bottom bar would just compete with it.
  const builderTitle = document.querySelector('.builder-title');
  if (builderTitle && summaryCta) {
    const NAV_OFFSET = 60; // top zone "reached" threshold (below sticky nav)
    function evaluateMobileVisibility() {
      if (isDesktop()) return;
      const titleRect = builderTitle.getBoundingClientRect();
      const summaryRect = summaryCta.getBoundingClientRect();
      const reachedBuilder = titleRect.top <= NAV_OFFSET;
      const passedSummary = summaryRect.bottom < NAV_OFFSET;
      const inZone = reachedBuilder && !passedSummary;
      bar.classList.toggle('is-hidden-builder', inZone);
    }
    window.addEventListener('scroll', evaluateMobileVisibility, { passive: true });
    window.addEventListener('resize', evaluateMobileVisibility);
    evaluateMobileVisibility();
  }

  // Re-evaluate on resize (desktop ↔ mobile boundary)
  window.addEventListener('resize', () => {
    if (!isDesktop()) {
      bar.classList.add('visible');
      document.body.classList.remove('has-sticky-cta');
    } else {
      bar.classList.remove('is-hidden-builder');
    }
  });
})();


// ───────── Testimonials: progressive disclosure + filter integration ─────────
(function setupTestimonials(){
  const INITIAL = 6;
  const EXPAND_BY = 6;
  let visible = INITIAL;
  let activeFilter = 'all';

  const cards = Array.from(document.querySelectorAll('.proof-card'));
  const pills = Array.from(document.querySelectorAll('.proof-filter .pill'));
  const btn   = document.querySelector('.proof-see-more');
  const btnWrap = document.querySelector('.proof-see-more-wrap');
  const countEl = btn ? btn.querySelector('.see-more-count') : null;
  const labelEl = btn ? btn.querySelector('.see-more-label') : null;

  function apply() {
    let matched = 0;
    let shown   = 0;
    cards.forEach(card => {
      const tags = (card.getAttribute('data-filter-tags') || '').split(/\s+/);
      const fits = activeFilter === 'all' || tags.includes(activeFilter);
      if (!fits) { card.classList.add('proof-hidden'); return; }
      matched++;
      // When filter is active → show all matching. When "all" → respect the visible limit.
      if (activeFilter !== 'all' || shown < visible) {
        card.classList.remove('proof-hidden');
        shown++;
      } else {
        card.classList.add('proof-hidden');
      }
    });

    // See more button: only visible in "all" view AND when there's something left to reveal
    if (btnWrap) {
      const hasMore = (activeFilter === 'all') && (matched > visible);
      btnWrap.style.display = hasMore ? '' : 'none';
      if (hasMore && countEl) {
        const remaining = matched - visible;
        countEl.textContent = '+ ' + remaining + ' more';
      }
    }
  }

  pills.forEach(pill => {
    pill.addEventListener('click', () => {
      activeFilter = pill.getAttribute('data-filter');
      pills.forEach(p => p.setAttribute('data-selected', p === pill ? 'true' : 'false'));
      if (activeFilter === 'all') visible = INITIAL;  // reset collapse when returning to all
      apply();
    });
  });

  if (btn) {
    btn.addEventListener('click', () => {
      visible += EXPAND_BY;
      apply();
    });
  }

  apply();
})();

// Initialize — run syncSelections first so UTM-driven size pill is visually selected,
// then updateSummary populates H1 size word, sticky bar, and order summary.
syncSelections();
updateSummary();

// ───────── Mobile / tablet hamburger nav drawer (<900px only) ─────────
(function setupNavDrawer(){
  const trigger  = document.querySelector('.nav-hamburger');
  const drawer   = document.querySelector('[data-nav-drawer]');
  const backdrop = document.querySelector('[data-nav-backdrop]');
  const closeBtn = document.querySelector('[data-nav-close]');
  const links    = document.querySelectorAll('[data-nav-link]');
  if (!trigger || !drawer || !backdrop) return;

  let lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    document.body.classList.add('nav-drawer-open');
    trigger.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    backdrop.setAttribute('aria-hidden', 'false');
    // Focus the first link for keyboard users (after the animation starts)
    setTimeout(() => {
      const firstLink = drawer.querySelector('.nav-drawer-link');
      if (firstLink) firstLink.focus();
    }, 120);
  }
  function close() {
    document.body.classList.remove('nav-drawer-open');
    trigger.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.setAttribute('aria-hidden', 'true');
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  }

  trigger.addEventListener('click', () => {
    const isOpen = document.body.classList.contains('nav-drawer-open');
    isOpen ? close() : open();
  });
  if (closeBtn) closeBtn.addEventListener('click', close);
  backdrop.addEventListener('click', close);

  // Close on link tap (so smooth-scroll to anchor isn't blocked by the drawer)
  links.forEach(link => link.addEventListener('click', close));

  // ESC closes
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.body.classList.contains('nav-drawer-open')) {
      close();
    }
  });

  // Auto-close if the viewport widens past the breakpoint (e.g., orientation flip)
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (window.innerWidth >= 900 && document.body.classList.contains('nav-drawer-open')) {
        close();
      }
    }, 80);
  });
})();

// ───────── Mobile / tablet hero carousel (<900px only) ─────────
// Scroll-snap drives the slides natively. JS just syncs dots + thumbs to the
// current slide index, fades the "Customized" pill on non-first slides, and
// scrolls to a slide when the user taps a thumbnail.
(function setupHeroCarousel(){
  const wrap   = document.querySelector('.hero-images-wrap');
  const imgs   = document.querySelector('.hero-images');
  const slides = Array.from(document.querySelectorAll('.hero-images .hero-img'));
  const dots   = Array.from(document.querySelectorAll('.hero-dots .hero-dot'));
  const thumbs = Array.from(document.querySelectorAll('.hero-thumbs .hero-thumb'));
  const thumbStrip = document.querySelector('.hero-thumbs');
  if (!imgs || !slides.length) return;

  let activeIdx = 0;
  function setActive(idx) {
    if (idx === activeIdx) return;
    activeIdx = idx;
    if (wrap) wrap.setAttribute('data-active-slide', String(idx));
    dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
    // Keep the active thumbnail visible in the strip (centered if possible)
    if (thumbStrip && thumbs[idx]) {
      const t = thumbs[idx];
      const stripRect = thumbStrip.getBoundingClientRect();
      const tRect = t.getBoundingClientRect();
      if (tRect.left < stripRect.left || tRect.right > stripRect.right) {
        const target = t.offsetLeft - (thumbStrip.clientWidth - t.clientWidth) / 2;
        thumbStrip.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      }
    }
  }
  if (wrap) wrap.setAttribute('data-active-slide', '0');

  // Detect which slide is centered using IntersectionObserver
  const io = new IntersectionObserver((entries) => {
    let best = { ratio: 0, idx: activeIdx };
    entries.forEach(entry => {
      if (entry.intersectionRatio > best.ratio) {
        const idx = slides.indexOf(entry.target);
        if (idx !== -1) best = { ratio: entry.intersectionRatio, idx };
      }
    });
    if (best.ratio > 0.55) setActive(best.idx);
  }, { root: imgs, threshold: [0, 0.25, 0.5, 0.75, 1] });
  slides.forEach(s => io.observe(s));

  // Thumb tap → scroll to corresponding slide
  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      if (slides[i] && imgs) {
        imgs.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      }
    });
  });
})();

